import { UserProfile, UserProfileRestricted } from 'components/userProfile';

import { useConversationRow } from '../../../utils/useConversationRow';

import styles from './conversationsTableCustomer.module.scss';

/** Represents the content of the customer cell in the conversations table. */
export const ConversationsTableCustomer = (): JSX.Element => {
  const {
    conversationAndRequester: { conversation, requester },
    isRestricted,
  } = useConversationRow();
  const subject =
    conversation.initial_channel === 'email' ||
    conversation.initial_channel === 'contact_form' ||
    conversation.initial_channel === 'trustpilotreviews'
      ? conversation.attributes.subject
      : undefined;
  const description = conversation.is_abandoned ? 'Abandoned' : subject;

  return isRestricted ? (
    <UserProfileRestricted />
  ) : (
    <UserProfile
      user={requester}
      truncateName
      description={description}
      descriptionClassName={styles.description}
    />
  );
};
